var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _polygon, _circle, _circle2, _circle3, _path, _polygon2, _polygon3, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _path2, _path3, _path4, _path5, _path6, _circle4, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ffc6eb9a-0ec0-429c-85a8-ff38b44048bf",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 896 748",
    style: {
      enableBackground: "new 0 0 896 748"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F2F2F2;}\r\n\t.st1{fill:#2F2E41;}\r\n\t.st2{fill:#3F3D56;}\r\n\t.st3{fill:#A0616A;}\r\n\t.st4{opacity:0.1;enable-background:new    ;}\r\n\t.st5{fill:#E8907A;}\r\n\t.st6{fill:#695A57;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 413.2,
    y: 35.9,
    className: "st0",
    width: 140,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 513.2,
    y: 37.4,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 452.2,
    y: 37.4,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 484.2,
    y: 131.9,
    className: "st0",
    width: 140,
    height: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 522.2,
    y: 113.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 583.2,
    y: 113.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 670.2,
    y: 176.9,
    className: "st0",
    width: 140,
    height: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 708.2,
    y: 158.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 769.2,
    y: 158.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 656.2,
    y: 640.9,
    className: "st0",
    width: 140,
    height: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 694.2,
    y: 622.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 755.2,
    y: 622.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 417.2,
    y: 319.9,
    className: "st0",
    width: 140,
    height: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 455.2,
    y: 301.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 516.2,
    y: 301.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 461.2,
    y: 560.9,
    className: "st0",
    width: 140,
    height: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 499.2,
    y: 542.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 560.2,
    y: 542.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 685.2,
    y: 487.9,
    className: "st0",
    width: 140,
    height: 2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 723.2,
    y: 469.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 784.2,
    y: 469.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "362.1,702.2 125.3,702.2 125.3,700.5 360.4,700.5 360.4,617.9 145.2,617.9 134.7,596.1 136.3,595.3  146.3,616.2 362.1,616.2 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 156.8,
    cy: 726,
    r: 17.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 333.1,
    cy: 726,
    r: 17.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 540.9,
    cy: 346.2,
    r: 11.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.4,589.8H121.2L63.6,401.5h383l-0.3,1.1L387.4,589.8z M122.5,588h263.6l58.2-184.8H66L122.5,588z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "366.6,580 132.8,580 82.3,413 418.7,413 418.4,414 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "451.5,384.7 449.8,384.3 461.1,341.9 526.4,341.9 526.4,343.6 462.4,343.6 "
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 82.3,
    y: 458.6,
    className: "st1",
    width: 345.3,
    height: 1.7
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 521.3,
    className: "st1",
    width: 306.3,
    height: 1.7
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 254.3,
    y: 402.4,
    className: "st1",
    width: 1.7,
    height: 186.5
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 233.6,
    y: 494.8,
    transform: "matrix(6.541722e-02 -0.9979 0.9979 6.541722e-02 -188.9443 789.5331)",
    className: "st1",
    width: 186.9,
    height: 1.7
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 182.5,
    y: 402.2,
    transform: "matrix(0.9979 -6.503739e-02 6.503739e-02 0.9979 -31.8467 12.9713)",
    className: "st1",
    width: 1.7,
    height: 186.9
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    y: 745,
    className: "st1",
    width: 896,
    height: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M595.4,61.9c0,0,14.6,41.6,5.6,48s30.4,58.7,30.4,58.7l47.2-12.8L652.8,112c0,0-3.4-43.7-3.4-50.1 S595.4,61.9,595.4,61.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M595.4,61.9c0,0,14.6,41.6,5.6,48s30.4,58.7,30.4,58.7l47.2-12.8L652.8,112c0,0-3.4-43.7-3.4-50.1 S595.4,61.9,595.4,61.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M570.9,358.5c0,0-4.3,53.3,0,81.1s10.7,104.5,10.7,104.5s0,145.1,23.5,147.2s40.5,4.3,42.7-4.3 s-10.7-12.8-4.3-17.1s8.5-19.2,0-36.3s0-189.9,0-189.9L684,552.6c0,0,4.3,89.6,8.5,102.4s-4.3,36.3,10.7,38.4s32-10.7,40.5-14.9 s-12.8-4.3-8.5-6.4s17.1-8.5,12.8-10.7s-8.5-104.5-8.5-104.5s-11.7-218.7-26.7-227.2s-24.5,6.2-24.5,6.2L570.9,358.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M609.3,682.8v17.1c0,0-19.2,46.4,0,46.4s34.1,4.8,34.1-1.6V687L609.3,682.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M735.2,682.7v17.1c0,0,19.2,46.4,0,46.4S701,751,701,744.6V687L735.2,682.7z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 625.3,
    cy: 54.4,
    r: 38.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M613.5,125.9c0,0,10.7,32,27.7,25.6l17.1-6.4l29.9,204.8c0,0-23.5,34.1-57.6,12.8S613.5,125.9,613.5,125.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M643.4,119.5l9.6-20.3c0,0,56.5,26.7,65.1,35.2c8.5,8.5,8.5,21.3,8.5,21.3l-14.9,53.3c0,0,4.3,117.4,4.3,121.6 s14.9,27.7,4.3,19.2s-12.8-17.1-21.3-4.3s-27.7,27.7-27.7,27.7L643.4,119.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M718.1,273.1l-6.4,59.7c0,0-38.4,34.1-29.9,36.3s12.8-6.4,12.8-6.4s14.9,14.9,23.5,6.4s29.9-89.6,29.9-89.6 L718.1,273.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M626.1,0.1c-8.5-0.3-17.6-0.5-24.8,4.1c-3.3,2.3-6.2,5.1-8.6,8.4c-7,8.8-13,20-10.4,30.9l3-1.2 c0,2.9-0.7,5.8-1.9,8.5c0.4-1.2,1.8,0.8,1.5,2l-3.3,10.9c5.5-2,12.3,2.1,13.1,7.8c0.4-12.7,1.7-27.2,12-34.6 c5.2-3.7,11.7-4.9,18-5.9c5.8-0.9,11.9-1.8,17.5,0.1s10.3,7.6,9.1,13.4c2.6-0.9,5.4,0.9,6.7,3.3s1.3,5.2,1.4,8 c2.7,1.9,5.9-1.9,7-5.1c2.6-7.4,4.9-15.3,3.5-23.1s-7.7-15.1-15.6-15.2c1-1,1.5-2.4,1.4-3.8l-6.5-0.5c1.6-0.2,3.2-1,4.3-2.3 C650.8,8.7,630.3,0.3,626.1,0.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M624.2,113.1c0,0-17.4-17-23.6-16s-14.8,16-14.8,16s-51.2,17.1-49.1,34.1c2.1,17.1,25.6,100.3,25.6,100.3 s19.2,100.3,2.1,111s81.1,38.4,83.2,25.6s6.4-140.8,0-160S624.2,113.1,624.2,113.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M696.5,150.4h26.4c0,0,18.4,81.1,20.6,89.6s6.4,49.1,4.3,49.1s-44.8-8.5-44.8-2.1L696.5,150.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M698,348H597c-9.9-45.3-10.7-89.1,0-131h101C681.7,258.1,680.7,301.6,698,348z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M555.9,292.3l29.9,12.8c0,0,57.6,8.5,57.6-14.9s-57.6-10.7-57.6-10.7l-19.2-6.1L555.9,292.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M562.3,134.4l-25.6,6.4l-19.2,113.1c0,0-6.4,29.9,4.3,32s40.5,19.2,40.5,19.2s4.3-32,12.8-32L553.8,256 l12.8-74.7L562.3,134.4z"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 60.2,
    y: 352.9,
    className: "st0",
    width: 140,
    height: 2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 98.2,
    y: 334.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 159.2,
    y: 334.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 109.2,
    y: 56.9,
    className: "st0",
    width: 140,
    height: 2
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 209.2,
    y: 58.4,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 148.2,
    y: 58.4,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 250.2,
    y: 253.9,
    className: "st0",
    width: 140,
    height: 2
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 350.2,
    y: 255.4,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 289.2,
    y: 255.4,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2,
    y: 252.9,
    className: "st0",
    width: 140,
    height: 2
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 112.2,
    y: 254.4,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 51.2,
    y: 254.4,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 180.2,
    y: 152.9,
    className: "st0",
    width: 140,
    height: 2
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 218.2,
    y: 134.9,
    className: "st0",
    width: 2,
    height: 18.5
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 279.2,
    y: 134.9,
    className: "st0",
    width: 2,
    height: 18.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty_cart.1c3412833354da7f66c8df82e4c36935.svg";
export { ForwardRef as ReactComponent };